import { Button } from "@mui/material";

export default function ButtonOk({ children, ...props }) {
  return (
    <Button
      variant="contained"
      color="blueSys"
      sx={{textTransform: "initial"}}
     {...props}
    >
      {children}
    </Button>
  );
}
